import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { API_URL } from '../constants';
import { BaseDataService, DataService } from '../core/services';
import { SettingModel } from '../models';

@Injectable()
export class SettingsService extends BaseDataService {

    constructor(protected dataService: DataService) {
        super(dataService, API_URL);
    }

    public getDailyReportFields() {
        let url = `DailyReportField`;
        return super.getAll<any>(url);
    }

    public getSettings(accountId: number, moduleId: number, siteId: number): Observable<any> {
        let url = `Setting/GetAll?accountId=${accountId}&moduleId=${moduleId}&siteId=${siteId}`;
        return super.getAll<any>(url);
    }

    public getValue(setting: string, accountId: number, siteId: number = 0): Observable<any> {
        let url = `Setting/GetValue?setting=${setting}&accountId=${accountId}&siteId=${siteId}`;
        return super.getAll<any>(url);
    }

    public getValueById(id: number): Observable<any> {
        let url = `Setting/GetValueById?id=${id}`;
        return super.getAll<any>(url);
    }

    public Save(model: SettingModel) {
        let url = `Setting/Save`;
        return super.save<any>(url, model);
    }

    public getAccountSettings(accountId: number) {
        let url = `Account/Settings?accountId=${accountId}`;
        return super.getAll<any>(url);
    }

    public accountSaveSettings(model: SettingModel) {
        let url = `Account/SaveSettings`;
        return super.save<any>(url, model);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/settings.service.ts